<template>
  <v-container fluid grid-list-xl>
    <v-card raised>
      <v-card-title class="display-1">Locations</v-card-title>

      <v-layout class="mx-0">
        <v-spacer></v-spacer>
        <v-flex xs-6>
          <v-text-field
            append-icon="search"
            label="Search"
            single-line
            hide-details
            v-model="search"
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout>
        <v-card-text class="grey--text">
          <p class="grey--text caption">
            <b>Changes:</b><br/>
            The monthly sales information is moved to the dedicated report section. Location details are shown instead.<br/>
            The data with be updated every few hours.
          </p>
        </v-card-text>
      </v-layout>
      <v-data-table
        :loading="loading"
        :items="locations"
        :headers="headers"
        :footer-props="{'items-per-page-options': [15, 30, 50, 100]}"
        :search="search"
        class="clickable"
        :options="locationPagination"
        mobile-breakpoint="0"
      >
        <template v-slot:item="{ item }">
          <tr @click="click(item)">
            <td>{{ item.name }}</td>
            <td>{{ item.address }}</td>
            <td>{{ item.vending_machine ? item.vending_machine.full_categories : '-' }}</td>
            <td>{{ item.vending_machine ? item.vending_machine.soldout_categories : '-' }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
  import locationService from '@/services/logistics/location'
  import paginationMixin from '@/mixins/pagination'

  export default {
    mixins: [
      paginationMixin
    ],

    created () {
      this.$store.commit('UPDATE_TITLE', '')

      // fetch data
      locationService.getAll(true, ['settings'])
        .then(({ data }) => {
          this.locations = data.data
        })
        .finally(() => {
          this.loading = false
        })
    },

    computed: {
      locationPagination () {
        return Object.assign(this.pagination, {
          sortBy: ['sale.amount'],
          sortDesc: [true],
        })
      },
    },

    data () {
      return {
        loading: true,

        headers: [
          {
            text: 'Location',
            value: 'name',
            align: 'left'
          },
          {
            text: 'Address',
            value: 'address',
            align: 'left'
          },
          {
            text: 'Total products',
            value: 'vending_machine.full_categories',
            align: 'left'
          },
          {
            text: 'Sold-out products',
            value: 'vending_machine.soldout_categories',
            align: 'left'
          }
        ],

        search: null,

        locations: [],
      }
    },

    methods: {
      click (item) {
        this.$router.push({
          name: 'LogisticsLocation',
          params: {
            'id': item.id
          }
        })
        this.$store.commit('UPDATE_TITLE', item.name_zh_hk)
      }
    }
  }
</script>

<style lang="stylus">
  .clickable
    tr:hover
      cursor pointer
</style>



// WEBPACK FOOTER //
// src/components/Logistics/Locations/Overview.vue